import { ServiceBase, IBaseEntity } from './ServiceBase';
import { post } from '../ReaderlyHttpClient';

export interface Author extends IBaseEntity {
}

export class AuthorsService extends ServiceBase<Author> {
  constructor() {
    super('authors');
  }

  async GetFiltered(searchString?: string, publisherIds?: number[]) {
    const request = {
      search: searchString ?? '',
      publishers: publisherIds ?? [],
    };
    return await post<Author[], typeof request>('authors/filters', request);
  }
}

const authorsServiceInstance = new AuthorsService();

export default authorsServiceInstance;
